





























import { computed, defineComponent, ref, toRefs } from '@vue/composition-api'
import { TagStyler } from '../../composables/useTagFormatter'
import TagIndicators from '../../components/transcript/TagIndicators.vue'
import { UITag } from '../../types/tag'
import { Word, WordTagStyles } from '../../models/word'
import { SEARCHED_WORD_CLASS_NAME } from '../../composables/useTextSearch'

export default defineComponent({
  name: 'KaiWord',
  components: {
    TagIndicators
  },
  props: {
    wordComponent: {
      type: Object as () => Word,
      required: true,
      default: {}
    },
    isWordUnderlined: {
      type: Boolean || undefined
    },
    isEditable: {
      type: Boolean,
      required: true,
      default: false
    },
    wordIndex: {
      type: Number,
      required: true,
      default: 0
    },
    totalWordsLength: {
      type: Number,
      required: true,
      default: 0
    },
    spelled: {
      type: Boolean,
      default: false
    },
    tags: {
      type: Array as () => UITag[],
      required: true,
      default: () => []
    }
  },
  setup(props, { emit }) {
    const {
      tags,
      wordIndex,
      isEditable,
      wordComponent,
      totalWordsLength,
      spelled
    } = toRefs(props)
    const wordRef = ref()
    const tagStyles = ref({})
    const text = ref(wordComponent.value.text.trim())
    const visible = ref(true)
    const timeout = ref(null)
    const clickCount = ref(0)

    function getText(styles: WordTagStyles) {
      let text = wordComponent.value.text.trim()

      if (
        !isEditable.value &&
        !text.length &&
        (styles.isRoundedLeft ||
          styles.isRoundedRight ||
          styles.isFullyBordered ||
          totalWordsLength.value === 0)
      ) {
        text = String.fromCharCode(160)
      }

      return text
    }

    function getIsVisible(styles: WordTagStyles): boolean {
      return !!(
        !!wordComponent.value.text.trim().length ||
        totalWordsLength.value === 0 ||
        (!isEditable.value &&
          !!wordComponent.value.text.trim().length &&
          (styles.isRoundedLeft ||
            styles.isRoundedRight ||
            styles.isFullyBordered))
      )
    }

    const styles = computed(() => {
      const isEdit = isEditable.value
      const sharedStyles = {
        'word-h': !isEdit,
        'word-editable': isEdit,
        'border-blue-defaultLight': isEdit,
        'border-gray-110': !isEdit,
        current: !isEdit && spelled.value,
        single: isEdit && wordComponent.value.isSingleInPart
      }

      if (!tags.value.length) {
        tagStyles.value = {}
        return {
          ...sharedStyles,
          'fully-rounded': false,
          'border-top-bottom': false,
          'rounded-left': false,
          'rounded-right': false,
          'with-background': false
        }
      }

      const _tagStyles: WordTagStyles = TagStyler.computeStyles(
        tags.value,
        wordIndex.value
      )
      text.value = getText(_tagStyles)

      if (!isEdit) {
        tagStyles.value = _tagStyles
        visible.value = getIsVisible(_tagStyles)
        return {
          ...sharedStyles,
          'fully-rounded': _tagStyles.isFullyBordered,
          'border-top-bottom': _tagStyles.hasTopBottomBorder,
          'rounded-left': _tagStyles.isRoundedLeft,
          'rounded-right': _tagStyles.isRoundedRight,
          'with-background': _tagStyles.isBackground
        }
      } else {
        visible.value =
          !wordComponent.value.isSpare || totalWordsLength.value === 0
        return sharedStyles
      }
    })

    function click() {
      const selection = window.getSelection()
      clickCount.value++
      if (clickCount.value === 2) {
        clickCount.value = 0
        clearTimeout(timeout.value)
        return
      }
      timeout.value = setTimeout(() => {
        clickCount.value = 0
        if (isEditable.value) {
          emit('part-focus')
        }
        if (selection) {
          if (selection.toString()) return
          emit('component-word-click', wordComponent.value)
        }
      }, 200)

      // emit('component-word-click', wordComponent.value)
      //
      // if (isEditable) {
      //     emit('part-focus')
      // }
    }

    function showTag(e) {
      emit('component-tag-click', { ...e, wordComponent: wordComponent.value })
    }

    function mouseOver(e) {
      emit('component-word-hover', { e, tags: tags.value })
    }

    function mouseLeave(e) {
      emit('component-word-leave', { e, tags: tags.value })
    }

    return {
      searched: SEARCHED_WORD_CLASS_NAME,
      tagStyles,
      styles,
      visible,
      text,
      wordRef,
      // tagsOnWordId,
      click,
      showTag,
      mouseOver,
      mouseLeave
    }
  }
})
